import { user } from './Utils';

const API_BASE_URL = process.env.REACT_APP_API_SERVER;

async function fetchAPI(path, options = {}) {
  let queryString = '';
  if (options.params) {
    const searchParams = new URLSearchParams(options.params);
    queryString = `?${searchParams.toString()}`;
    delete options.params;
  }

  const url = `${API_BASE_URL}${path}${queryString}`;

  const headers = options.body instanceof FormData ? options.headers : {
    'Content-Type': 'application/json',
    ...options.headers,
  };

  const response = await fetch(url, {
    ...options,
    headers
  });

  if (response.status === 401) {
    localStorage.removeItem('auth');
    window.location.href = '/auth/sign-up';
    //return response.json();
  }

  if (response.status === 422
    || response.status === 400 
    || response.status === 403 
    || response.status === 404
    || response.status === 413 
    || response.status === 400) {
    return response.json();
  }

  if (!response.ok) {
    throw new Error(`API call failed: ${url}, status: ${response.status}`);
  }

  return response.json();
}

function userAuth(){
  return { 'Authorization': `Bearer ${user().accessToken}`};
}

export const apiService = {
  async checklogin(data) { return fetchAPI('/auth/telegram-login/check', { method: 'POST', body: JSON.stringify(data)});},
  async login(data) { return fetchAPI('/auth/telegram-login', { method: 'POST', body: JSON.stringify(data)});},
  // profile
  async getMe() { return fetchAPI('/users/me', { method: 'GET', headers: userAuth()});},
  async deleteMe() { return fetchAPI('/users/me', { method: 'DELETE', headers: userAuth()});},
  // files
  async deleteImage(data) { return fetchAPI('/upload', { method: 'DELETE', body: JSON.stringify(data), headers: userAuth()});},
  async upload(data) { return fetchAPI('/upload', { method: 'POST', body: data, headers: userAuth()});},
  async getTransactions(params) { return fetchAPI('/transactions', { method: 'GET', params, headers: userAuth()});},
  // games
  async gameInfo() { return fetchAPI('/games/bonus-wheel', { method: 'GET', headers: userAuth()});},
  async gamePlay() { return fetchAPI('/games/bonus-wheel/play', { method: 'GET', headers: userAuth()});},
  // groups
  async getGroups(params) { return fetchAPI('/groups', { method: 'GET', params, headers: userAuth()});},
  async getGroupsMe(params) { return fetchAPI('/groups/me', { method: 'GET', params, headers: userAuth()});},
  async getGroupsApproved(params) { return fetchAPI('/groups/approved', { method: 'GET', params, headers: userAuth()});},
  async getGroup(params) { return fetchAPI('/groups/'+params.id, { method: 'GET', headers: userAuth()});},
  async getGroupLiked(params) { return fetchAPI('/groups/'+params.id+'/users', { method: 'GET', params, headers: userAuth()});},
  async likeGroup(data) { return fetchAPI('/groups/like', { method: 'PUT', body: JSON.stringify(data), headers: userAuth() });},
  async dislikeGroup(data) { return fetchAPI('/groups/dislike', { method: 'PUT', body: JSON.stringify(data), headers: userAuth() });},
  async approvedToGroup(data) { return fetchAPI('/groups/approved/'+data.groupId, { method: 'PUT', body: JSON.stringify(data), headers: userAuth() });},
  async rejectedFromGroup(data) { return fetchAPI('/groups/rejected/'+data.groupId, { method: 'PUT', body: JSON.stringify(data), headers: userAuth() });},
  async createGroup(data) { return fetchAPI('/groups', { method: 'POST', body: JSON.stringify(data), headers: userAuth()});},
  async updateGroup(data) { return fetchAPI('/groups/'+data.id, { method: 'PATCH', body: JSON.stringify(data), headers: userAuth() });},
  async deleteGroup(params) { return fetchAPI('/groups/'+params.id, { method: 'DELETE', headers: userAuth()});},
};